import { generateTestId } from "@client-shared";
import type { VariantStatusBadgesTestIds } from "@bcc/components/products/product-select-form";

export const setConfigureStepTestId = (identifier: string): string => generateTestId("ConfigureStep", identifier);

export const setProductFormCollapsibleTestId = (identifier: string): string => generateTestId("ProductFormCollapsible", identifier);

/** Badge test ids for a collapsible's header (§13.1 parity with the Select-step row). */
export const getProductFormCollapsibleBadgeTestIds = (uuid: string): VariantStatusBadgesTestIds => ({
  totalVariantsText: setProductFormCollapsibleTestId(`total-variants-text-${uuid}`),
  totalVariantsCount: setProductFormCollapsibleTestId(`total-variants-count-${uuid}`),
  noVariantsDetected: setProductFormCollapsibleTestId(`no-variants-detected-${uuid}`),
  allVariantsImported: setProductFormCollapsibleTestId(`all-variants-imported-${uuid}`),
  importedLive: setProductFormCollapsibleTestId(`imported-live-${uuid}`),
  importedPending: setProductFormCollapsibleTestId(`imported-pending-${uuid}`),
  importedRejected: setProductFormCollapsibleTestId(`imported-rejected-${uuid}`),
});
